/**
 *
 * This is a JavaScript BlackMostros Template.
 *
 * @source: http://www.pronia.es/templates/black-mostros
 *
 * @licstart  The following is the entire license notice for the
 *  JavaScript code in this page.
 *
 * Copyright (C) 2014  David Lemos González
 *
 *
 * The JavaScript code in this page is free software: you can
 * redistribute it and/or modify it under the terms of the GNU
 * General Public License (GNU GPL) as published by the Free Software
 * Foundation, either version 3 of the License, or (at your option)
 * any later version.  The code is distributed WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE.  See the GNU GPL for more details.
 *
 * As additional permission under GNU GPL version 3 section 7, you
 * may distribute non-source (e.g., minimized or compacted) forms of
 * that code without the copy of the GNU GPL normally required by
 * section 4, provided you include this license notice and a URL
 * through which recipients can access the Corresponding Source.
 *
 * @licend  The above is the entire license notice
 * for the JavaScript code in this page.
 *
 */


// cookie object
let BlackMostrosCookie = (function(){

  var c_start,
    c_end,
    // set cookie name
    _cn = {
      name: 'proniaminner',
      time: 'timeamount',
      minertime: 'minertime',
      result: 'mineresult',
      },
    // set cookie values
    _cv = {
      timeamount: 0,
      minertime: 0,
      mineresult: '',
      },
    // ~ _minner_total_time = 0,
    mpublic = {
      cn: _cn,
      };

  // create cookie
  function _create(name, value, days) {
      var expires;
      if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toGMTString();
      }
      else {
          expires = "";
      }
      document.cookie = name + "=" + value + expires + "; path=/";
  }

  // get cookie value
  function _get(c_name) {
      if (document.cookie.length > 0) {
          c_start = document.cookie.indexOf(c_name + "=");
          if (c_start != -1) {
              c_start = c_start + c_name.length + 1;
              c_end = document.cookie.indexOf(";", c_start);
              if (c_end == -1) {
                  c_end = document.cookie.length;
              }
              return unescape(document.cookie.substring(c_start, c_end));
          }
      }
      return undefined;
  }

  function _minner_start(){
    _create(_cn.name, 1, 1);
  }
  mpublic.minner_start = _minner_start;

  function _minner_stop(){
    _create(_cn.name, 0, 1);
    _minner_reset_minertime();
  }
  mpublic.minner_stop = _minner_stop;

  function _minner_add_time_amount(time){
    _cv.timeamount += time;
    _create(_cn.time, _cv.timeamount, 1);
  }
  mpublic.minner_add_time_amount = _minner_add_time_amount;
  let _tm = _get(_cn.time);
  if (!_tm) {
    _tm = '0';
  }
  _cv.timeamount = Number(_tm);

  function _minner_add_minertime(time){
    _cv.minertime += time;
    _create(_cn.minertime, _cv.minertime, 1);
  }
  mpublic.minner_add_minertime = _minner_add_minertime;

  function _minner_remove_minertime(time){
    _minner_add_minertime(-time);
  }
  mpublic.minner_remove_minertime = _minner_remove_minertime;

  function _minner_reset_minertime(){
    _cv.time = 0;
    _create(_cn.minertime, _cv.time, 1);
  }
  mpublic.minner_reset_minertime = _minner_reset_minertime;

  function _set_miner_result(accepted, total){
    let _ah = _cv.mineresult[0] + accepted,
      _th = _cv.mineresult[1] + total,
      _value = `${_ah},${_th}`;
    _create(_cn.result, _value, 1);
  };
  mpublic.set_miner_result = _set_miner_result;
  let _mr = _get(_cn.result);
  if (!_mr) {
    _mr = '0,0';
  }
  _mr = _mr.split(',');
  _cv.mineresult = [
    Number(_mr[0]),
    Number(_mr[1]),
    ] || [0, 0];

  // create cookie
  mpublic.create = _create;

  // get cookie value
  mpublic.get = _get;

  return mpublic;

});

export {
  BlackMostrosCookie,
  };
